import { PERMISSION } from '@/constants/permission.constant';

const pageList = () => import('@/views/pages/List.vue');
const homeEdit = () => import('@/views/pages/HomeEdit.vue');
const sellCar = () => import('@/views/pages/SellCarEdit.vue');
const afterSaleEdit = () => import('@/views/pages/AfterSaleEdit.vue');
const AuctionEdit = () => import('@/views/pages/AuctionEdit.vue');
const OurStoryEdit = () => import('@/views/pages/OurStoryEdit.vue');
const TermUseEdit = () => import('@/views/pages/TermUseEdit.vue');
const PolicyEdit = () => import('@/views/pages/PolicyEdit.vue');

export const pageRoute = [
  {
    path: '/pages',
    name: 'page',
    component: pageList,
    meta: {
      requiresAuth: false,
      permissions: [
        PERMISSION.HOME_READ,
        PERMISSION.SELL_CAR_READ,
        PERMISSION.AFTER_SALES_SERVICES_READ,
        PERMISSION.AUCTIION_READ,
        PERMISSION.OUR_STORY_READ,
        PERMISSION.TERM_OF_USE_READ,
        PERMISSION.PRIVACY_POLICY_READ,
      ],
    },
  },

  {
    path: '/pages/:id/home',
    name: 'home-edit',
    component: homeEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.BHOME_UPDATE] },
  },
  {
    path: '/pages/:id/sell-car',
    name: 'sell-car-edit',
    component: sellCar,
    meta: { requiresAuth: false, permissions: [PERMISSION.SELL_CAR_UPDATE] },
  },
  {
    path: '/pages/:id/after-sale',
    name: 'after-sale-edit',
    component: afterSaleEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.AFTER_SALES_SERVICES_UPDATE] },
  },
  {
    path: '/pages/:id/auction',
    name: 'auction-edit',
    component: AuctionEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.AUCTIION_UPDATE] },
  },
  {
    path: '/pages/:id/our-stories',
    name: 'our-story-edit',
    component: OurStoryEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.OUR_STORY_UPDATE] },
  },
  {
    path: '/pages/:id/term-use',
    name: 'term-use-edit',
    component: TermUseEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.TERM_OF_USE_UPDATE] },
  },
  {
    path: '/pages/:id/policies',
    name: 'privacy-policy-edit',
    component: PolicyEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.PRIVACY_POLICY_UPDATE] },
  },
];
